var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllust3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "167px",
    viewBox: "0 0 180 167",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_growth_analytics_re_pyxf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 63,
    cy: 64,
    r: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-116.7%",
    y: "-83.3%",
    width: "333.3%",
    height: "333.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 99,
    cy: 59,
    r: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-116.7%",
    y: "-83.3%",
    width: "333.3%",
    height: "333.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-5",
    cx: 114,
    cy: 74,
    r: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-116.7%",
    y: "-83.3%",
    width: "333.3%",
    height: "333.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-7",
    cx: 81,
    cy: 69,
    r: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-116.7%",
    y: "-83.3%",
    width: "333.3%",
    height: "333.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-9",
    cx: 45,
    cy: 75,
    r: 3
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-116.7%",
    y: "-83.3%",
    width: "333.3%",
    height: "333.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stepper-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"",
    transform: "translate(-1020.000000, -320.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_growth_analytics_re_pyxf",
    transform: "translate(1020.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b85ae1dc-b170-4f54-a6de-4a72451950d7",
    fillOpacity: 0.2,
    fill: "#000000",
    x: 0,
    y: 7,
    width: 155,
    height: 102
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f015ec3e-20cc-40e8-8473-d753a9bdb685",
    fill: "#FFFFFF",
    x: 6,
    y: 15.5,
    width: 144,
    height: 86.4166667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "ed585d6d-4c60-4aae-9dcd-e3012a759289",
    fill: "#C9B181",
    x: 0,
    y: 0,
    width: 155,
    height: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b43fe0fb-7393-4bbe-8dcd-48ed75608891",
    fill: "#FFFFFF",
    cx: 6.5,
    cy: 3.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ada3e127-c3a1-446f-8730-bf32ed0f9b11",
    fill: "#FFFFFF",
    cx: 11.5,
    cy: 3.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e3927273-efa9-4ef7-88ca-a022a07a6d22",
    fill: "#FFFFFF",
    cx: 16.5,
    cy: 3.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.018869,91 L122.092857,90.5110219 L115.541851,75.4750873 C114,72 112.715423,67.3245217 110.475419,64.8559259 L110.452274,64.8300403 C108.931867,63.0822522 103.850721,58.6464232 98.5934615,59.0225155 C95.8163377,59.2205844 93.4387228,60.7539641 91.5268108,63.580114 C85.5755422,72.3804035 77.7579679,69.4098247 73.6276633,66.855887 C69.9876833,64.604678 66.2703419,63.5480538 62.5781622,63.7162185 C57.4072111,63.9478913 50.1290641,66.130352 44.8211538,75.2124092 C42.7938763,78.6783907 34.823372,87.7460661 25.3310727,90.5110219 L27.018869,91 Z",
    id: "Path",
    fillOpacity: 0.2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.676552,91 L21.3234481,91 C21.1448163,91 21,90.844172 21,90.6519572 L21,37.3480428 C21,37.1558241 21.1448126,37 21.3234481,37 C21.5020835,37 21.6468961,37.1558241 21.6468961,37.3480428 L21.6468961,90.3039143 L124.676552,90.3039143 C124.855187,90.3039143 125,90.4597384 125,90.6519572 C125,90.8441759 124.855187,91 124.676552,91 L124.676552,91 Z",
    id: "Path",
    fill: "#19222F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#19222F",
    x: 44,
    y: 75,
    width: 1.66666667,
    height: 15.8333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#19222F",
    x: 62,
    y: 66,
    width: 2,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#19222F",
    x: 80,
    y: 71,
    width: 2,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#19222F",
    x: 98,
    y: 61,
    width: 2,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#19222F",
    x: 113,
    y: 76,
    width: 2,
    height: 15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C9B181",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C9B181",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C9B181",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C9B181",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C9B181",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E616A",
    points: "162.999337 164 160.289417 164 159 153 163 153.000233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.999836,167 L155,166.99963 L155,166.873746 C155.000136,164.734373 156.568407,163.000115 158.502989,163 L158.503216,163 L164,163.000252 L163.999836,167 Z",
    id: "Path",
    fill: "#19222F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#9E616A",
    points: "153.999337 164 151.289417 164 150 153 154 153.000233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.999836,167 L146,166.99963 L146,166.873746 C146.000136,164.734373 147.568407,163.000115 149.502989,163 L149.503216,163 L155,163.000252 L154.999836,167 Z",
    id: "Path",
    fill: "#19222F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.545324,86.4182847 C121.029283,87.0784377 121.783189,87.4920628 122.604179,87.5478618 C123.42517,87.6036609 124.228912,87.295902 124.799133,86.7073969 L130.718092,89 L133,85.7721008 L124.595441,82.6509457 C123.511393,81.7464685 121.916629,81.7891524 120.883336,82.7503004 C119.850042,83.7114484 119.704826,85.2872567 120.545319,86.4182847 L120.545324,86.4182847 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#19222F",
    points: "154.250068 105 147 107.492427 149.421986 161.602896 155.017294 161.74882 157.880776 123.58926 158.531103 161.598111 165.449538 162 168 105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.457027,72.2490526 L167.844099,68 L170,84.8389405 L168.204819,92.8847167 L168.923883,105.112004 C168.923883,105.112004 153.594244,112.808353 146,106.544255 C146,106.544255 152.103841,90.3721636 148.565813,82.8016255 L148.457027,72.2490526 Z",
    id: "Path",
    fill: "#C9B181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.442244,75.5594873 L148.029059,73.0061419 C148.029059,73.0061419 147.827449,72.7091142 144.983128,76.2462528 C142.138807,79.7833915 136.368764,85.4097875 136.368764,85.4097875 L126.752025,81.5736084 L125,88.4595345 L136.176619,94 L152,82.7586885 L151.442244,75.5594873 Z",
    id: "Path",
    fill: "#C9B181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.315408,112.737841 C169.93116,112.403988 170.386446,111.774242 170.558757,111.018055 C170.731068,110.261868 170.602703,109.456919 170.208203,108.819807 L173,103.705302 L170.705834,101 L166.851667,108.28624 C165.943125,109.136503 165.732249,110.632335 166.360816,111.768061 C166.989382,112.903788 168.25871,113.320423 169.315408,112.737855 L169.315408,112.737841 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,72.3627725 L168.029278,69.0908961 C168.029278,69.0908961 171.404582,67.9235293 174.162275,73.955768 C176.919967,79.9880067 180,92.2237088 180,92.2237088 L172.798678,106 L167.206019,103.518212 L172.798678,92.1264373 L166.880478,83.6902177 L165,72.3627725 Z",
    id: "Path",
    fill: "#C9B181"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    transform: "translate(156.753063, 62.425295) rotate(-28.663160) translate(-156.753063, -62.425295) ",
    cx: 156.753063,
    cy: 62.425295,
    r: 6.28209298
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.464562,57.3970807 L162.763449,56.8002582 L161.259526,56.0589338 C161.259526,56.0589338 159.600459,53.3807415 156.598315,54.1333754 C153.59617,54.8860093 152.245453,55.336438 152.245453,55.336438 L150.745334,56.0852928 L151.498235,56.8284998 L150.147558,57.2789469 L151.049907,57.7237415 L150,58.3224466 L150.565186,61.3916168 C150.565186,61.3916168 151.503923,59.0637686 153.308618,59.953351 C155.113312,60.8429333 158.414374,59.4934931 158.414374,59.4934931 L161.282267,65 C161.282267,65 161.873915,63.0696948 162.928787,63.5844038 C162.92881,63.5844084 165.623734,59.3263998 162.464562,57.3970807 Z",
    id: "Path",
    fill: "#19222F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.766234,167 L126.233766,167 C126.104661,167 126,166.776142 126,166.5 C126,166.223858 126.104661,166 126.233766,166 L179.766234,166 C179.895339,166 180,166.223858 180,166.5 C180,166.776142 179.895339,167 179.766234,167 Z",
    id: "Path",
    fill: "#CACACA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllust3);
export default __webpack_public_path__ + "static/media/illust_3.d4790cf17980868292ec58aac397cfaa.svg";
export { ForwardRef as ReactComponent };